import { getNettingConfirmation, saveNetting, sendNettingConfirmation } from "../../../networking/NetworkingOrders";

const transformNettingDetail = (ordersBuy, ordersSell) =>{
    const nettinDetailsToSave = [] ;
    if(ordersBuy && ordersBuy.length > 0)
    {
        ordersBuy.forEach((o, index) =>{
        const detail = {
            OrderID: o.BNOrderNo,
            OrderOriginalTotal: o.TotalNetOrderNumber,
            AmountNetted: o.amountToApply,
            SettlementStatus: (o.TotalNetOrderNumber - o.amountToApply) === 0 ? 'Fully Paid' : 'Partially Paid'
        }
        nettinDetailsToSave.push(detail);
        })
    }
    if(ordersSell && ordersSell.length > 0){
        ordersSell.forEach((o, index) =>{
          const detail = {
            OrderID: o.BNOrderNo,
            OrderOriginalTotal: o.TotalNetOrderNumber,
            AmountNetted: o.amountToApply,
            SettlementStatus: (o.TotalNetOrderNumber - o.amountToApply) === 0 ? 'Fully Paid' : 'Partially Paid'
          }
          nettinDetailsToSave.push(detail);
        })
    }
  return nettinDetailsToSave
}

export const save = async(customerId, buyCurrency, ordersBuy, ordersSell, totalBuy, totalSell) =>{
   
  const objNetting = {
    CustomerID: customerId,
    SettlementCurrency: buyCurrency,
    NettingDetails: transformNettingDetail(ordersBuy, ordersSell),
    NettingTotalBuy: totalBuy,
    NettingTotalSell: totalSell,
    NettingBalance: (totalBuy - totalSell < 0) ? totalSell - totalBuy : totalBuy - totalSell,
    UserID: localStorage.getItem('userID')
  }

  const responseSave = await saveNetting(objNetting);

  console.log(responseSave);
  if(responseSave.httpStatusCode !== 200)
  {
    return {Title: 'Error', Message: responseSave.Message, Success: false, NettingID: 0}
  }
  else{
    const messageSave = `Netting was saved successfully. Netting ID: ${responseSave.NettingID} `
    return {Title: 'Success', Message: messageSave, Success: true, NettingID: responseSave.NettingID}
  }
}

export const getConfirmation = async(nettingID) =>{
  const responseConfirmation = await getNettingConfirmation(nettingID);
      const httpStatusCode = responseConfirmation.httpStatusCode;
      switch (httpStatusCode) {
        case 200:
          if (responseConfirmation != null && responseConfirmation.data != null) {
            const fileName = 'Netting Confirmation ' + nettingID + '.pdf';
            const byteCharacters = atob(responseConfirmation.data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const bytes = new Uint8Array(byteNumbers);
            const mimeType = 'application/pdf';//mime.lookup(fileName);
            const blob = new Blob([bytes], {
              type: mimeType 
            });
            
            return {Success: true, Title:'', Message:'', File:blob, FileName: fileName}
          }
          break;
        default:
          return {Success: false, Title:'Error', Message:'Please try again or contact the administrator',File:null, FileName:''}
          break;
      }
}

export const sendConfirmation = async(OrderID) =>{
  const response = await sendNettingConfirmation(OrderID);
  if(response.httpStatusCode !== 200)
    return {Success:false, Title: 'Error', Message:'An error occurred while trying to send confirmattion. Please try again..'};
  else
    return {Success:true, Title: 'Success', Message:'Netting confirmation sent successfully'}
}

